<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>基础设置</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
               <el-form-item label="客户名称:" prop="customerName">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.customerName"></el-input>
              </el-form-item>
              <el-form-item label="合同编号:" prop="contractNo">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.contractNo"></el-input>
              </el-form-item>
              <el-form-item label="流向:" prop="flowtoType">
                <el-select v-model="searchFrom.flowtoType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in liuXiangOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary"  @click="chaXun" btnCode='00DP005B001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  @click="chongZhi" btnCode='00DP005B002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="tongBuClick" btnCode='00DP005B003' v-if="btnFlg[2]">同步合同数据</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeBtnClick" btnCode='00DP005B004' v-if="btnFlg[3]">设置</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="contractNo"   label="合同编号" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName"    label="客户名称"  show-overflow-tooltip align="center" ></el-table-column>
        <el-table-column property="flowtoTypeName" label="流向"  align="center" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="weightFlg"    label="计重方式" align="center" >
          <template slot-scope="scope"><div>
              <span v-if="scope.row.weightFlg=='A'">实重</span>
              <span v-if="scope.row.weightFlg=='T'">理重</span>
            </div></template>
        </el-table-column>
        <el-table-column prop="fleetName" label="车队" align="center"  show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="receAddress"  label="收货地址" align="center"   show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <!-- <el-table-column prop="topLimit"    label="每日发货上限" align="center" width="150" :formatter="emptyFn"></el-table-column> -->
        <!-- <el-table-column prop="weekAutoflg" label="自动生成计划时间" align="center" width="180" show-overflow-tooltip :formatter="emptyFn"></el-table-column> -->
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--修改计划-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeMark"
    width="920px"
    center>
      <span>
         <el-form
          :model="changeFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          ref="changeFrom"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox">
                <el-form-item label="合同编号:" >
                <el-col :span="6" >
                  <el-form-item  prop="heTongBianHao">
                    <span>{{changeFrom.heTongBianHao}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="13">
                  <el-form-item label="客户名称:" prop="changeKeHuName">
                    <span>{{changeFrom.changeKeHuName}}</span>
                  </el-form-item>
                </el-col>
                </el-form-item>
                <el-form-item label="流向:" >
                <el-col :span="7" >
                  <el-form-item  prop="liuXiang">
                    <el-select v-model="changeFrom.liuXiang" @change="liuXiangChange" :validate-event = "false" placeholder="请选择" style="width:150px;">
                      <el-option
                        v-for="(item,index) in liuXiangOptions"
                        :key="index"
                        :label="item.showName"
                        :value="item.itemNo">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="运输车队:" prop="changeFleet" v-if="cheDuiShow">
                    <el-select v-model="changeFrom.changeFleet" @change="cheDuiselect"  placeholder="请选择" style="width:150px;">
                      <el-option
                        v-for="(item,index) in changeFleetOptions"
                        :key="index"
                        :label="item.tenantName"
                        :value="item.tenantCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                </el-form-item>
              <el-form-item label="收货地址:" prop="address" style="margin-top:10px;">
                <el-input  placeholder="" maxlength="100"   v-model.trim="changeFrom.address" style="width:508px;"></el-input>
             </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'  @click="changeBaoCun('changeFrom')"  :loading='addShengChengLoading'>保存</el-button>
        <el-button @click="quXiaoClick('changeFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  TenantDictionary, // 字典
  jiChuGuanLiChaXun, // 查询
  modifyContract, // 修改
  jiChuGuanLiChangeFleet // 修改页面-车队下拉框
} from '@/api/zhb'
import { getBtn } from '@/utils/getButton'
import { encryption, emptyFn } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP005B001', '00DP005B002', '00DP005B003',
        '00DP005B004'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10
      },
      liuXiangOptions: [],
      changeFleetOptions: [],
      value: '',
      tableList: [],
      // 修改
      changeMark: false,
      addShengChengLoading: false,
      jiHuaDateOptions: [ ],
      // 新增验证
      rules: {
        // name: [
        //   { required: true, message: '请输入租户名称', trigger: 'blur' }
        // ],
        // business: [
        //   { type: 'array', required: true, message: '请至少选择一个业务板块', trigger: 'change' }
        // ],
        changeFleet: [
          { required: true, message: '车队不能为空', trigger: 'blur' }
        ],
        jiHuaShangXian: [
          { required: true, message: '自动生成计划上限不能为空', trigger: 'blur' }
        ]
      },
      changeFrom: {
        jiHuaDate: ['周四'],
        jiHuaDateStr: '',
        heTongBianHao: '',
        changeKeHuName: '',
        liuXiang: '',
        changeFleet: '',
        changeName: '',
        address: '',
        jiHuaShangXian: '',
        changeId: ''
      },
      cheDuiObj: {},
      newDateArr: [],
      cheDuiShow: false, // 控制车队显示隐藏
      selectData:[],
      flowtoTypeFlag:0
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.getDictionary()
    this.getSearchData(this.searchFrom)
    this.btnFlg = getBtn(this.btnIdArr, '/basicSettings')
  },
  methods: {
    // 车队下拉框的值改变触发的事件
    cheDuiselect (vid) {
      this.cheDuiObj = this.changeFleetOptions.find((item) => {
        return item.tenantCode === vid
      })
      // console.log(this.cheDuiObj.tenantName, '000000')
      // console.log(this.cheDuiObj.tenantCode, '000000')
    },
    // 获取流向字典数据
    getDictionary () {
      TenantDictionary({
        groupNo: 'flowto_type'
      }).then(res => {
        this.liuXiangOptions = res
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {

      })
    },
    // 查询接口
    getSearchData () {
      jiChuGuanLiChaXun(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {

      })
    },
    // 点击查询
    chaXun () {
      this.getSearchData(this.searchFrom)
    },
    // 点击重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        customerName: '',
        contractNo: '',
        flowtoType: ''
      }
      this.getSearchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSearchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSearchData(this.searchFrom)
    },
    // 点击修改按钮
    changeBtnClick () {
      // this.selectData = []
      // this.selectData = this.$refs.tableRef.selection
      // console.log(this.selectData,'selectData')
      if (this.selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if(this.selectData.length > 1){
        this.$message.error('请选择一条数据进行操作')
      }else{
        this.changeMark = true
        this.title = '合同编辑'
        // 车队下拉框
        jiChuGuanLiChangeFleet().then(res => {
          this.changeFleetOptions = res
          // console.log(this.changeFleetOptions)
        }).catch(err => {
          this.$message.error(err.message)
        })
        this.changeFrom.changeId = this.selectData.id
        this.changeFrom.heTongBianHao = this.selectData.contractNo // 合同编号
        this.changeFrom.changeKeHuName = this.selectData.customerName // 客户名称
        this.changeFrom.liuXiang = this.selectData.flowtoType // 流向
        if (this.changeFrom.liuXiang == '1') {
          this.cheDuiShow = true
          this.changeFrom.changeFleet = this.selectData.fleetCode // 车队
        } else {
          this.cheDuiShow = false
          this.changeFrom.changeFleet = '' // 车队
          this.changeFrom.changeName = '' // 车队名称
        }
        if(this.changeFrom.liuXiang == ''){
          this.flowtoTypeFlag = '0'
        }else{
          this.flowtoTypeFlag = '1'
        }
        this.changeFrom.address = this.selectData.receAddress // 收货地址
        this.changeFrom.jiHuaDateStr = this.selectData.weekAutoflg // 生成计划时间
        this.changeFrom.jiHuaDate = this.changeFrom.jiHuaDateStr.split(',')
        // console.log(this.changeFrom.jiHuaDate,'this.changeFrom.jiHuaDate')
        // 去除数组里的空字符串
        // this.changeFrom.jiHuaDate.filter(function (s) {
        //   return s && s.trim();
        // });
        this.changeFrom.jiHuaShangXian = this.selectData.topLimit // 生成 计划上限
      }
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row,'888888')
      // this.$refs.tableRef.toggleRowSelection(row)
      this.selectData = row
    },
    handleTabCurrentChange (val) {
      // this.currentRow = val
    },
    // 流向的值改变时触发的事件
    liuXiangChange () {
      if (this.changeFrom.liuXiang == '1') {
        this.cheDuiShow = true
      } else {
        this.cheDuiShow = false
        this.changeFrom.changeFleet = ''
        this.changeFrom.changeName = ''
      }
    },
    // 修改保存
    changeBaoCun (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 同时获取车队下拉框的valu和lable值
          this.changeFleetOptions.forEach((item, index) => {
            if (this.changeFrom.changeFleet == item.tenantCode) {
              this.changeFrom.changeName = item.tenantName
            }
          })
          // 去除数组里的空字符串
          this.changeFrom.jiHuaDate = this.changeFrom.jiHuaDate.filter(function (s) {
            return s && s.trim()
          })
          // this.changeFrom.jiHuaDate = this.changeFrom.jiHuaDate.toString()
          let str = this.changeFrom.jiHuaDate.toString()
          // console.log(this.changeFrom.jiHuaDate,'2222')
          let from = {
            id: this.changeFrom.changeId,
            // contractNo: this.changeFrom.heTongBianHao,
            // customerName: this.changeFrom.changeKeHuName,
            flowtoType: this.changeFrom.liuXiang,
            fleetCode: this.changeFrom.changeFleet,
            fleetName: this.changeFrom.changeName,
            receAddress: this.changeFrom.address
            // weekAutoflg: str,
            // topLimit: this.changeFrom.jiHuaShangXian
          }
          if(this.flowtoTypeFlag == '1'){
            this.$confirm('修改流向或车队后，是否撤销该合同下已派未装的运单数据？', '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              closeOnClickModal: false,
              showClose:false,
              type: 'warning'
            })
            .then(() => {
              this.addShengChengLoading = true
              modifyContract(1,from).then(res => {
                this.$message.success('修改成功！')
                this.addShengChengLoading = false
                this.changeMark = false
                this.getSearchData(this.searchFrom)
              }).catch(err => {
                this.addShengChengLoading = false
                this.$message.error(err.message)
              })
            })
            .catch(() => {
              this.addShengChengLoading = true
              modifyContract(0,from).then(res => {
                this.$message.success('修改成功！')
                this.addShengChengLoading = false
                this.changeMark = false
                this.getSearchData(this.searchFrom)
              }).catch(err => {
                this.addShengChengLoading = false
                this.$message.error(err.message)
              })
            })
          }else{
              this.addShengChengLoading = true
              modifyContract(1,from).then(res => {
                this.$message.success('修改成功！')
                this.addShengChengLoading = false
                this.changeMark = false
                this.getSearchData(this.searchFrom)
              }).catch(err => {
                this.addShengChengLoading = false
                this.$message.error(err.message)
              })
          }
          
          // alert('submit!');
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 修改取消
    quXiaoClick (formName) {
      this.$refs[formName].resetFields()
      this.changeMark = false
    },
    tongBuClick () {
      this.getSearchData(this.searchFrom)
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBox{
  margin-left: 10px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
